<template>
    <module-card
        v-bind="params"
        :loading="loading"
        :error="error"
        :errorText="errorText"
        :permissions="permissions"
        :retryFunction="retryFunction"
        :segmentations="segmentations"
        :canShow="canShow"
        @visibleChanged="$emit('visibleChanged', $event)"
    >
        <template slot="content">
            <div>
                <div class="support-card__item">
                    <div class="support-card__item__label">
                        Solicitações em aberto
                    </div>
                    <div class="support-card__item__value">
                        {{ openTicketsCount }}
                    </div>
                </div>
                <div class="support-card__item">
                    <div class="support-card__item__label">
                        Solicitações resolvidas
                    </div>
                    <div class="support-card__item__value">
                        {{ closeTicketsCount }}
                    </div>
                </div>
                <div class="support-card__item">
                    <div class="support-card__item__label">
                        Ultima solicitação -
                        {{ this.formatDateTime(lastTicketDate) }}
                    </div>
                    <div class="support-card__item__value">
                        #{{ lastTicketNumber }}
                    </div>
                </div>
            </div>
        </template>
        <template slot="actions">
            <v-btn
                class="slin-btn"
                @click="$router.push({ name: 'ticketForm' })"
                :style="{ color: params.themeColor }"
            >
                <i class="bexsicon-plus-sm" />
                Nova solicitação
            </v-btn>
            <v-btn
                class="slin-btn"
                @click="$router.push({ name: 'ticketList' })"
                :style="{ color: params.themeColor }"
            >
                <i class="bexsicon-docs-sm" />
                Acompanhar solicitações
            </v-btn>
        </template>
    </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import { CONFIG, PROFILES, TICKET_CRM } from '../../utils/constants';

export default {
  components: {
    ModuleCard
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    error: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    errorText: String,
    retryFunction: Function
  },
  data() {
    return {
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE
      ],
      segmentations: []
    };
  },
  computed: {
    canShow() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    },
    openTicketsCount() {
      const { inAnalysis, waitingReply, inProgress } = this.item;
      const inAnalysisCount = inAnalysis ? inAnalysis.length : 0;
      const waitingReplyCount = waitingReply ? waitingReply.length : 0;
      const inProgressCount = inProgress ? inProgress.length : 0;
      return inAnalysisCount + waitingReplyCount + inProgressCount;
    },
    closeTicketsCount() {
      return this.item.done ? this.item.done.length : 0;
    },
    lastTicketNumber() {
      if (this.item.lastTicket) return this.item.lastTicket.number;
    },
    lastTicketDate() {
      if (this.item.lastTicket) return this.item.lastTicket.openDate;
    }
  }
};
</script>

<style lang="scss" scoped>
.support-card {
  &__item {
    border-bottom: 1px solid rgb(240, 240, 240);
    padding: 0.5em;
    display: flex;

    &__label {
      font-size: 0.9em;
      flex: 0.8;
    }

    &__value {
      text-align: right;
      font-size: 1em;
      flex: 0.2;
      color: var(--label-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/SupportCard.vue